function renderAddressParagraph(label, ci) {
    if (!ci && !label) {
        return null
    }
    const line =
        (ci?.address_1 || '') +
        (ci?.city ? ' ' + ci.city : '') +
        (ci?.state ? ' ' + ci.state : '') +
        (ci?.zip ? ' ' + ci.zip : '')
    const trimmed = line.trim()
    if (!label && !trimmed) {
        return null
    }
    return <p>
        {label ? <strong>{label}: </strong> : null}
        {trimmed}
    </p>
}

export default function DisplayAnAddress({ data, labelOverride, claimLine, faxLine }) {
    if (!data || typeof data !== 'object') {
        return null
    }

    // Attorney / law firm: match LawFirmAddress — use office location when set, else law firm mailing address
    if (data.law_firm) {
        const firmOrLocationName = (data.law_firm.name || data.location?.name || '').trim()
        const attorneyName = data.attorney?.first_name ? String(data.attorney.first_name + ' ' + data.attorney.last_name).trim() : ''
        const label =
            firmOrLocationName && attorneyName
                ? `${attorneyName}, ${firmOrLocationName}`
                : firmOrLocationName || attorneyName
        const ci =
            data.location?.contact_information ||
            data.law_firm.contact_information
        return <>
            {renderAddressParagraph(label, ci)}
            {claimLine ? <p>{claimLine}</p> : null}
            {faxLine ? <p>{faxLine}</p> : null}
        </>
    }

    // Insurance rows, or case-attorney rows without law_firm (location / carrier / attorney person contact)
    const label =
        labelOverride ||
        data.location?.name ||
        data.insurance_carrier?.name ||
        data.attorney?.name
    const ci =
        data.location?.contact_information ||
        data.insurance_carrier?.contact_information ||
        data.attorney?.contact_information

    return <>
        {renderAddressParagraph(label, ci)}
        {claimLine ? <p>{claimLine}</p> : null}
        {faxLine ? <p>{faxLine}</p> : null}
    </>
}
